import { AppState } from '../../../../redux/store';
import { Army, Folder, Version } from '../../../../models';

export const getVersions = (state: AppState): Array<Version> =>
  state.versions.entity ?? [];

export const getArmies = (state: AppState): Array<Army> =>
  state.armies.entity ?? [];

export const getFolders = (state: AppState): Array<Folder> =>
  state.folders.entity ?? [];

export const getVersionsLoading = (state: AppState): boolean =>
  state.versions.isLoading;

export const getArmiesLoading = (state: AppState): boolean =>
  state.armies.isLoading;

export const getFoldersLaoding = (state: AppState): boolean =>
  state.folders.isLoading;

export const getArmyListLoading = (state: AppState): boolean =>
  state.armyList.isLoading;

export const getArmyListsLoading = (state: AppState): boolean =>
  state.armyLists.isLoading;

export const getMyContestLaoding = (state: AppState): boolean =>
  state.myContest.isLoading;
